define(['../chartConfig/staticConfig.js', './autocomplete_us', './autocomplete_eu'], function(staticConfig, autocomplete_us, autocomplete_eu) {
    'use strict';

    var acDataManager = {
        //Fields: autocomplete_us.Fields,
        //Securities: staticConfig.Securities,
        fetchData: function(params, callback) {
            if (params.autoComplete.dataSource.toUpperCase() === 'EU') {
                autocomplete_eu.fetchData(params, callback);
            } else {
                autocomplete_us.fetchData(params, callback);
            }
        },
        fetchRelatedTickersAndMajorIndexData: autocomplete_us.fetchRelatedTickersAndMajorIndexData
    };
    return acDataManager;
});


//////////////////
// WEBPACK FOOTER
// ./components/svgchart/src/js/manager/data/autocomplete.js
// module id = 63
// module chunks = 0